import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/70' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-white"></i>
            </div>
            <span className={`font-heading font-bold text-xl transition-colors duration-300 ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
              基德漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname === link.to
                    ? scrolled ? 'text-primary-600' : 'text-primary-300'
                    : scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200">
              <i className="ri-search-line text-base"></i>
              <span>搜索漫画</span>
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-950' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer py-2 ${
                  location.pathname === link.to ? 'text-primary-600' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button className="flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 mt-1">
              <i className="ri-search-line text-base"></i>
              <span>搜索漫画</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}